import { useState, useEffect } from 'react';
import axios from 'axios';

const useModuleSettings = () => {
  const [moduleSettings, setModuleSettings] = useState({
    videoCourses: false, // Default to false to match new defaults
    prospector: false,
    outlookCalendar: false
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchModuleSettings = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setLoading(false);
          return;
        }

        const response = await axios.get('/api/settings/modules', {
          headers: { 'x-auth-token': token }
        });

        if (response.data) {
          setModuleSettings({
            videoCourses: response.data.video_courses_enabled === true, // Default to false if undefined
            prospector: response.data.prospector_enabled === true,
            outlookCalendar: response.data.outlook_calendar_enabled === true
          });
        }
      } catch (error) {
        console.error('Error fetching module settings:', error);
        // Keep defaults if API fails
      } finally {
        setLoading(false);
      }
    };

    fetchModuleSettings();
  }, []);

  return { moduleSettings, loading };
};

export default useModuleSettings;